<template>
  <div>
<!--    <portlet-->
<!--        :actionsBlock="true"-->
<!--        :icon="'fad fa-project-diagram'"-->
<!--        :title="'Collectie deleter'"-->
<!--    >-->
<!--      <template slot="actionsBlock">-->

<!--      </template>-->
<!--      <template slot="portletBody">-->
<!--        <div class="row">-->
<!--          <div class="col">-->
<!--            <label for="company">companyID</label>-->
<!--            <select id="company" class=" form-control" v-model="deleteCollectionCompany.companyId">-->
<!--              <option :key="company.id+1" :value="company.id" v-for="company in companies"> {{ company.name }} - -->
<!--                {{ company.id }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->
<!--          <div class="col">-->
<!--            <label for="collection">Collectie naam</label>-->
<!--            <input type="text" class="form-control" id="collection" v-model="deleteCollectionCompany.collection">-->
<!--          </div>-->

<!--          <div class="col-2">-->
<!--            <label for="">&nbsp; </label>-->
<!--            <br>-->
<!--            <button class="btn btn-danger" @click="deleteCollectionForCompany()">DELETE COLLECTION</button>-->
<!--          </div>-->
<!--        </div>-->


<!--      </template>-->

<!--    </portlet>-->
    <portlet
        :actionsBlock="true"
        :icon="'fad fa-project-diagram'"
        :title="'Page settings'"
    >
      <template slot="actionsBlock">

      </template>
      <template slot="portletBody">
        <div class="row">
              <div class="col-12">
                <CompanyCreator></CompanyCreator>
          </div>


        </div>


      </template>

    </portlet>

    <portlet
        :actionsBlock="true"
        :icon="'fad fa-project-diagram'"
        :title="'Page settings'"
    >
      <template slot="actionsBlock">

      </template>
      <template slot="portletBody">
        <div class="row">
          <div class="col-3">
            <label for="company">select company for Page settings</label>
            <select id="company" class=" form-control" v-model="selectedCompany">
              <option :key="company.id+1" :value="company.id" v-for="company in companies"> {{ company.name }} -
                {{ company.id }}
              </option>
            </select>
          </div>

          <PageSettings :selectedCompany="selectedCompany"/>

        </div>


      </template>

    </portlet>





    <portlet
        :actionsBlock="true"
        :icon="'fad fa-project-diagram'"
        :title="'Jobs table config'"
    >
      <template slot="actionsBlock">

      </template>
      <template slot="portletBody">
        <div class="row">
          <label for="company">select company for job table settings</label>
          <select id="company" class=" form-control" v-model="selectedCompany">
            <option :key="company.id+'-1'" :value="company.id" v-for="company in companies"> {{ company.name }} -
              {{ company.id }}
            </option>
          </select>
        </div>

        <company-config v-if="selectedCompany && rendered" :selectedCompany="selectedCompany"/>

      </template>

    </portlet>

<!--    <portlet-->
<!--        :actionsBlock="false"-->
<!--        :icon="'fad fa-project-diagram'"-->
<!--        :title="'UI settings'"-->
<!--    >-->

<!--      <template slot="portletBody">-->
<!--        <div class="row">-->
<!--          <div class="col-12">-->
<!--            <label for="company">select company for UI settings</label>-->
<!--            <select id="company" class=" form-control" v-model="selectedCompany">-->
<!--              <option :key="company.id+1" :value="company.id" v-for="company in companies"> {{ company.name }} - -->
<!--                {{ company.id }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->

<!--          <UISettings :selectedCompany="selectedCompany"/>-->

<!--        </div>-->


<!--      </template>-->

<!--    </portlet>-->

  </div>
</template>

<script>

import {mapGetters} from 'vuex';
// import {dataTables} from './../../../mixins/dataTables';
import CompanyConfig from '../../components/root/CompanyJobsTable'
import PageSettings from "@/components/root/PageSettings";
import UISettings from "@/components/root/UISettings";
import CompanyCreator from "@/components/root/CompanyCreator.vue";
//@vuese
//@group UserManagement
export default {
  name: 'RootConfig',
  components: {
    CompanyConfig,
    // UISettings,
    CompanyCreator,
    PageSettings
  },
  mixins: [],
  data() {
    return {
      rendered: true,
      selectedCompany: null,
      companies: [],
      deleteCollectionCompany: {
        companyId: null,
        collection: ''
      }

    };
  },
  firestore() {
    return {
      companies: this.claims.root ? this.$FB.collection('companies').where('name','!=','Motivate') : this.$FB.collection('companies').doc(this.claims.companyId)
    };
  },
  methods: {
    copy(from, to) {
      this.$FUNCTIONS.copyCollection(from, to);
    },
    deleteCollectionForCompany() {
      this.$FUNCTIONS.deleteCollection(this.deleteCollectionCompany);
    }
    // @vuese
    // Sets up the columns for datatables package from https://git.motivate.nl/js-awesome/motivate-framework-components/blob/v2/src/components/DataTable.vue

  },
  computed: {
    ...mapGetters('users', [
      'getMe'
    ]),
    //@vuese
    // Get user claims
    claims() {
      return this.$FirebaseAuth.getClaims();
    }

  },
  watch: {
    selectedCompany() {
      this.rendered = false;
      this.$nextTick(() => {
        this.rendered = true;
      });

    }
  },
  created() {

  }
};
</script>
<style lang="scss">

</style>
